export const iconSize = {
  desktop: 100,
  mobile: 40,
};

export const mainColor = '#98d98e';
